import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
    selector: 'app-simulador-seguro',
    templateUrl: './simulador-seguro.component.html',
    styleUrls: ['./simulador-seguro.component.css'],
    standalone: false
})
export class SimuladorSeguroComponent implements OnInit {

  constructor(private renderer: Renderer2) {
  }

  ngOnInit() {
    this.renderer.addClass(document.body, 'app-autoatendimento');
  }

}
